module.exports = __webpack_public_path__ + "media/Loops 90 Bass.2c3cdc49.wav";